




























































import { Component, Vue, Prop } from 'vue-property-decorator';
import { PayServiceModel } from '@/models/payservice';
import { DATA } from '@/config/data';

@Component
export default class AmountDetailPayService extends Vue {
    @Prop({default: null})
    private payservice!: PayServiceModel;

    get payServiceTypes() {
        return DATA.payServiceTypes;
    }
}
